import React from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle,
} from 'mdb-react-ui-kit';
import { Form } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const SliderImageModal = ({ showModal, setShowModal, renderLink, imgDoc, closeModal, title }) => {
  const { t } = useTranslation();

  return (
    <>
      {/* <div
  className={`fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 ${showModal ? 'block' : 'hidden'}`}
  onClick={(e) => closeModal(e)}
>
  <div
    className="bg-green-50 w-auto h-auto max-w-[80vw] max-h-[80vh] rounded-lg shadow-lg flex flex-col justify-between overflow-y-hidden"
    onClick={(e) => e.stopPropagation()} // Prevents modal from closing when clicking inside
  >
    <Form className="h-full w-full">
      <div className="flex justify-between items-center px-6 py-1 border-b border-gray-300">
        <h2 className="text-customgreen font-semibold text-2xl">{t('Image View')}</h2>
        <MDBBtn
          type="button"
          className="btn-close"
          color="none"
          onClick={(e) => closeModal(e)}
        ></MDBBtn>
      </div>

      <div className="flex-grow flex justify-center items-center p-4 overflow-auto">
        {renderLink !== '' ? (
          <img
            src={`${renderLink ?? imgDoc?.doc}`}
            className="w-auto h-auto max-w-full max-h-full object-cover"
            alt="img.jpg"
          />
        ) : (
          <img
            src={`data:image/jpeg;base64,${imgDoc}`}
            className="w-auto h-auto max-w-full max-h-full object-cover"
            alt="img.jpg"
          />
        )}
      </div>
    </Form>
  </div>
</div> */}

      {/* <div
  className={`fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 ${showModal ? 'block' : 'hidden'}`}
  onClick={(e) => closeModal(e)}
>
  <div
    className="bg-green-50 w-auto h-auto max-w-[80vw] max-h-[80vh] rounded-lg shadow-lg flex flex-col justify-between"
    onClick={(e) => e.stopPropagation()} 
  >
    <Form className="h-full w-full">
      <div className="flex justify-between items-center px-6 py-1 border-b border-gray-300">
        <h2 className="text-customgreen font-semibold text-2xl">{t('Image View')}</h2>
        <MDBBtn
          type="button"
          className="btn-close"
          color="none"
          onClick={(e) => closeModal(e)}
        ></MDBBtn>
      </div>

      <div className="flex-grow flex justify-center items-center p-4 overflow-auto max-h-[70vh]"> 
        <div className="flex justify-center items-center h-full">
          {renderLink !== '' ? (
            <img
              src={`${renderLink ?? imgDoc?.doc}`}
              className="max-w-full max-h-full object-contain"
              alt="img.jpg"
            />
          ) : (
            <img
              src={`data:image/jpeg;base64,${imgDoc}`}
              className="max-w-full max-h-full object-contain" 
              alt="img.jpg"
            />
          )}
        </div>
      </div>
    </Form>
  </div>
</div> */}

      <div
        className={`fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50 ${showModal ? 'block' : 'hidden'}`}
        onClick={(e) => closeModal(e)}
      >
        <div
          className="bg-green-50 max-w-[80dvw] max-h-[80dvh] rounded-lg shadow-lg flex flex-col m-auto"
          onClick={(e) => e.stopPropagation()}
        >
          <Form className="h-full w-full flex flex-col">
            <div className="flex justify-end items-center px-6 py-2 border-b border-gray-300">
              <MDBBtn type="button" className="btn-close" color="none" onClick={(e) => closeModal(e)}></MDBBtn>
            </div>

            <div className="flex-grow flex justify-center items-center overflow-auto">
              {renderLink !== '' ? (
                <img
                  src={`${renderLink ?? imgDoc?.doc}`}
                  className="max-w-[100%] max-h-[100%] object-contain"
                  alt="img.jpg"
                />
              ) : (
                <img
                  src={`data:image/jpeg;base64,${imgDoc}`}
                  className="max-w-[100%] max-h-[100%] object-contain"
                  alt="img.jpg"
                />
              )}
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default SliderImageModal;
